import { useEffect } from 'react';
import { useNavigate } from '@usas/ui-web/wrappers/ReactRouterDom';

import NavLinks from './NavLinks';

import useSecurityData from '@usas/ui-web/state/security/UseSecurityData';

import Constants from '@usas/ui-web/utils/Constants';

const TAXONOMIES = ['BatchProcess'];
const SCOPE = 'BatchProcess';

const useTimeBatchProcessContextView = () => {
  const navigate = useNavigate();
  const { securityState, getContextSecurity } = useSecurityData();

  const onHomeClicked = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    navigate(NavLinks.ROOT);
  };

  useEffect(() => {
    //TODO: set context security to the logged in user's Id
    getContextSecurity(Constants.DEFAULT_POSITIVE_ID, TAXONOMIES, SCOPE);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [securityState]);

  return {
    onHomeClicked
  };
};

export default useTimeBatchProcessContextView;